import serviceTipoPregunta from '@/services/GsEncuesta/tipoPregunta'

export default {
  TIPO_PREGUNTA_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      serviceTipoPregunta.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  TIPO_PREGUNTA_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceTipoPregunta.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  TIPO_PREGUNTA_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      serviceTipoPregunta.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  TIPO_PREGUNTA_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      serviceTipoPregunta.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
